import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: null, // keep other dashboard data here if needed
	loading: false,
	selectedaccount: null,
	pagination: {
		currentPage: 1,
		perPage: 20,
		total: 0,
		totalPages: 0,
	},
};

const dashboardSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setGeolocationslist: (state, action) => {
			state.data = action.payload || [];

			state.pagination = {
				currentPage: action.payload?.pagination.current_page,
				perPage: action.payload?.pagination.per_page,
				total: action.payload?.pagination.total,
				totalPages: action.payload?.pagination.last_page,
			};
		},
		setLoadingDashboard: (state, action) => {
			state.loading = action.payload;
		},

		setSelectedAccountNumber: (state, action) => {
			state.selectedaccount = action.payload;
		},

		setappendGeolocationslist: (state, action) => {
			const newData = action.payload;

			if (!newData?.starlink_geo_location) return;

			const existing = state.data?.starlink_geo_location || [];
			const newItems = newData.starlink_geo_location;

			// Append new items to existing geolocation data
			state.data = {
				...newData,
				starlink_geo_location: [...existing, ...newItems],
			};

			// Update pagination with new page info
			state.pagination = {
				currentPage: newData.pagination.current_page,
				perPage: newData.pagination.per_page,
				total: newData.pagination.total,
				totalPages: newData.pagination.last_page,
			};
		},
	},
});

export const {
	setGeolocationslist,
	setLoadingDashboard,
	setSelectedAccountNumber,
	setappendGeolocationslist,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
